import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import EnumeratorField from '@shared/fields/enumerator-field';
import { TeamField } from '@modules/team/team-field';
import { PlayerField } from '@modules/player/player-field';

function label(name) {
  return i18n(`entities.sheetEvent.fields.${name}`);
}

function enumeratorLabel(name, value) {
  return i18n(`entities.sheetEvent.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  type: new EnumeratorField('type', label('type'), [
    { id: 'game', label: enumeratorLabel('type', 'game') },
    { id: 'goal', label: enumeratorLabel('type', 'goal') },
    { id: 'card', label: enumeratorLabel('type', 'card') },
    { id: 'penaltyShootout', label: enumeratorLabel('type', 'penaltyShootout') },
  ],{
    "required": true
  }),
  subtypeGame: new EnumeratorField('subtypeGame', label('subtypeGame'), [
    { id: 'start', label: enumeratorLabel('subtypeGame', 'start') },
    { id: 'firstHalfEnd', label: enumeratorLabel('subtypeGame', 'firstHalfEnd') },
    { id: 'seconndHalfStart', label: enumeratorLabel('subtypeGame', 'seconndHalfStart') },
    { id: 'secondHalfEnd', label: enumeratorLabel('subtypeGame', 'secondHalfEnd') },
    { id: 'end', label: enumeratorLabel('subtypeGame', 'end') },
    { id: 'cancelStart', label: enumeratorLabel('subtypeGame', 'cancelStart') },
  ],{}),
  subtypeGoal: new EnumeratorField('subtypeGoal', label('subtypeGoal'), [
    { id: 'standard', label: enumeratorLabel('subtypeGoal', 'standard') },
    { id: 'own', label: enumeratorLabel('subtypeGoal', 'own') },
    { id: 'penalty', label: enumeratorLabel('subtypeGoal', 'penalty') },
  ],{}),
  subtypeCard: new EnumeratorField('subtypeCard', label('subtypeCard'), [
    { id: 'yellowCard', label: enumeratorLabel('subtypeCard', 'yellowCard') },
    { id: 'redCard', label: enumeratorLabel('subtypeCard', 'redCard') },
  ],{}),
  subtypePenaltyShootout: new EnumeratorField('subtypePenaltyShootout', label('subtypePenaltyShootout'), [
    { id: 'start', label: enumeratorLabel('subtypePenaltyShootout', 'start') },
    { id: 'goal', label: enumeratorLabel('subtypePenaltyShootout', 'goal') },
    { id: 'fail', label: enumeratorLabel('subtypePenaltyShootout', 'fail') },
    { id: 'end', label: enumeratorLabel('subtypePenaltyShootout', 'end') },
  ],{}),
  teamId: TeamField.relationToOne('teamId', label('teamId'), {
    "required": true
  }),
  minute: new DateTimeField('minute', label('minute'), {}),
  player: PlayerField.relationToOne('player', label('player'), {
    "required": true
  }),
  otherTeamId: TeamField.relationToOne('otherTeamId', label('otherTeamId'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  minuteRange: new DateTimeRangeField(
    'minuteRange',
    label('minuteRange'),
  ),
};

export class SheetEventModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
